import type { Channel, ItemStatus } from "@stratcms/sdk";
import { h, icon } from "./dom";

export const STATUS_LABEL: Record<ItemStatus, string> = {
  draft: "Draft",
  in_review: "In review",
  changes_requested: "Changes requested",
  approved: "Approved",
  scheduled: "Scheduled",
  publishing: "Publishing",
  published: "Published",
  failed: "Failed",
  archived: "Archived",
};

export const CHANNEL_LABEL: Record<Channel, string> = { blog: "Blog", linkedin: "LinkedIn", instagram: "Instagram", youtube: "YouTube" };

export function statusPill(s: ItemStatus) {
  return h("span", { class: `pill st-${s}` }, STATUS_LABEL[s]);
}

export function channelBadge(c: Channel, withText = true) {
  return h("span", { class: `ch ch-${c}`, title: CHANNEL_LABEL[c] }, icon(c === "blog" ? "blog" : c, "ic ic-sm"), withText ? CHANNEL_LABEL[c] : null);
}

